// The built-in "Default" report — a config-driven encoding of the legacy
// hardcoded Revenue KPI dashboard. It is composed entirely of `builtin` groups
// (each delegating to its `KPI_METRIC_GROUPS` slug), so the config-driven
// renderer reproduces the existing dashboard byte-for-byte: same group order,
// same connector-gating + setup prompts, same dynamic groups, and same special
// rendering (custom-spend editor, separate brand-value query, conditional
// marginal metrics).
//
// This order MUST stay in sync with `DEFAULT_TABLE_SETTINGS.order` in
// `apps/ui-rtk/src/pages/Revenue/KPI/constants/settings.ts`. (The shared lib
// can't import from the UI app; a spec test asserts the two stay aligned.)

import type { KpiTableSlug } from './metric-groups';
import { REPORT_CONFIG_VERSION, type BuiltinReportGroup, type ReportConfig } from './report-config';

export const DEFAULT_REPORT_ID = 'default';
export const DEFAULT_REPORT_NAME = 'KPI Dashboard';

export const BUILTIN_DEFAULT_GROUP_ORDER: readonly KpiTableSlug[] = [
  'adSpend',
  'mer',
  'croWebMerch',
  'searchKPIs',
  'brandValue',
  'brandValueBreakdown',
  'digitalEngagement',
  'brand',
  'gaRevenue',
  'shopifyRevenue',
  'shopifyCustomer',
  'shopifyEcommRevenue',
  'shopifyRetailRevenue',
  'amazonRevenue',
  'wholesale',
  'shopifyContribution',
  'revenueBreakdown',
  'metaAdsReachImpressions',
  'metaAdsAudienceSegments',
  'traffic',
  'averageOrderValues',
  'totalBusinessRevenue',
];

export const DEFAULT_REPORT_CONFIG: ReportConfig = {
  version: REPORT_CONFIG_VERSION,
  groups: BUILTIN_DEFAULT_GROUP_ORDER.map(
    (slug): BuiltinReportGroup => ({
      kind: 'builtin',
      id: slug,
      slug,
    }),
  ),
};
